import Box from "@mui/material/Box";
import { useEffect, useState, useContext } from "react";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { SapImportFilterAndSearch } from "./SapImportFilterAndSearch";
import { importTrackingActions } from "../../service/importtracking.actions";
import FileSaver from "file-saver";
import IconButton from "@mui/material/IconButton";
import dayjs from "dayjs";
import Tooltip from "@mui/material/Tooltip";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../../../../util/state/GlobalContextProvider";
import { setSnackbar } from "../../../../util/state/globalAction";
import { snackbarTypes } from "../../../../util/state/globalVariables";
import CustomLoader from "../../../../util/component/CustomLoader";
import { Card, Chip } from "@mui/material";
import { IServerSideGetRowsParams } from "ag-grid-community";
import { FileTextWithIcon } from "../common/FileTextWithIcon";
import { ContextOperation } from "../../context/OperationContext";
import SectionHeader from "../../../../util/component/SectionHeader";
import AgGridOperationTable from "../common/AgGridOperationTable";

export const SapImportTable = ({type}: any) => {


  const userImportTracking = importTrackingActions();
  const { dispatchGlobalData } = useContext(GlobalContext);
  const { t } = useTranslation(["operation"]);
  const [pageSize, setPageSize] = useState<number>(10);
  const [length, setLength] = useState<number>(0);
  const [loading, setIsLoading] = useState<boolean>(false);
  const [gridApi, setGridApi] = useState<any>(null);

  const [resetFormValueImportTracking, setResetFormValueImportTracking] = useState<boolean>(false);
  const [
    dataFormSearchFieldImportTracking,
    setDataFormSearchFieldImportTracking,
  ] = useState<any>({
    fileName: "",
    status: "",
    startDateFrom: null,
    startDateTo: null,
  });
  const { tenant } = useContext(ContextOperation);
  const [rowData, setRowData] = useState<any>([]);
  const columnDefs: any = [
    {
      field: "fileName",
      headerName: type === "VEHICLE" ? t("sapImport.sapFile") : t("sapImport.sapFileTelematics"),
      flex: 1.3,
      cellRenderer: (cellValues: any) => SapFileCsvColumn(cellValues),
    },
    {
      field: "startDate",
      headerName: t("sapImport.startDate"),
      flex: 0.8,
      cellRenderer: (cellValues: any) => startDateColumn(cellValues),
    },
    {
      field: "endDate",
      headerName: t("sapImport.endDate"),
      flex: 0.8,
      cellRenderer: (cellValues: any) => endDateColumn(cellValues),
    },
    {
      field: "errorFilename",
      headerName: t("sapImport.failReport"),
      flex: 1.3,
      cellRenderer: (cellValues: any) => FailReportColumn(cellValues),
    },
    {
      field: "status",
      headerName: t("sapImport.status"),
      flex: 0.6,
      cellRenderer: (cellValues: any) => StatusColumn(cellValues),
    },
  ];

  const startDateColumn = (cellValues: any) => {
    return (
      // <Stack direction="row"
      //            fontWeight={400}
      //            height={'inherit'}
      //           fontSize={10}
      //            alignItems="center">
      //   {dayjs(`${cellValues.data.startDate}`).format("DD/MM/YYYY-HH:mm")}
      // </Stack>

      <>
        {cellValues.data.startDate ? (
          <Box component="span" width="inherit" height="inherit">
            {dayjs(cellValues.data.startDate).format("DD/MM/YYYY-HH:mm")}
          </Box>
        ) : (
          <Box> </Box>
        )}
      </>
    );
  };
  const endDateColumn = (cellValues: any) => {
    return (
      // <Stack direction="row"
      //            fontWeight={400}
      //            height={'inherit'}
      //           fontSize={10}
      //            alignItems="center">
      //   {dayjs(`${cellValues.data.endDate}`).format("DD/MM/YYYY-HH:mm")}
      // </Stack>
      <>
        {cellValues.data.endDate ? (
          <Box component="span" width="inherit" height="inherit">
            {dayjs(cellValues.data.endDate).format("DD/MM/YYYY-HH:mm")}
          </Box>
        ) : (
          <Box> </Box>
        )}
      </>
    );
  };
  const SapFileCsvColumn = (cellValues: any) => {
    return (
      <FileTextWithIcon
        onDownloadFile={() => {
          handleFileColumnClick(cellValues);
        }}
        fileTextDownload={cellValues.data.fileName}
        maxWidth="100%"
      />
    );
  };
  const FailReportColumn = (cellValues: any) => {
    if (!!cellValues.data.errorFilename) {
      return (
        <FileTextWithIcon
          onDownloadFile={() => {
            handleErrorFileColumnClick(cellValues);
          }}
          fileTextDownload={cellValues.data.errorFilename}
          fileTextColorRed={true}
        />
      );
    } else {
      return cellValues.data.errorFilename;
    }
  };

  const StatusColumn = (cellValues: any) => {
    switch (cellValues.data.status) {
      case "PROCESSED":
        return (
          <Chip
            label={t("internOptionSelectName.statusType.processed")}
            variant="filled"
            color="success"
          />
        );
      case "PENDING":
        return (
          <Chip
            label={t("internOptionSelectName.statusType.pending")}
            variant="filled"
            color="warning"
          />
        );
      case "WITH_ERRORS_CSV_FORMAT":
        return (
          <Chip
            label={t("internOptionSelectName.statusType.csvError")}
            variant="filled"
            color="error"
          />
        );
      case "WITH_ERRORS_DATA_INTEGRITY":
        return (
          <Chip
            label={t("internOptionSelectName.statusType.dataIntegrityError")}
            variant="filled"
            color="error"
          />
        );
      case "WITH_ERRORS_GENERIC_ERROR":
        return (
          <Chip
            label={t("internOptionSelectName.statusType.genericError")}
            variant="filled"
            color="error"
          />
        );
      default:
        return "";
    }
  };
  const SearchImportTracking = () => {
    let fileNameOne = !!dataFormSearchFieldImportTracking.fileName
      ? dataFormSearchFieldImportTracking.fileName.trim()
      : null;
    let statusOne = !!dataFormSearchFieldImportTracking.status
      ? dataFormSearchFieldImportTracking.status.trim()
      : null;
    let startDateFrom = dayjs(
      dataFormSearchFieldImportTracking?.startDateFrom
    ).isValid()
      ? dayjs
          .utc(dataFormSearchFieldImportTracking?.startDateFrom)
          .format("YYYY-MM-DDTHH:mm:ssZ")
      : null;
    let startDateTo = dayjs(
      dataFormSearchFieldImportTracking?.startDateTo
    ).isValid()
      ? dayjs
          .utc(dataFormSearchFieldImportTracking?.startDateTo)
          .format("YYYY-MM-DDTHH:mm:ssZ")
      : null;

    return {
      getRows: async (params: IServerSideGetRowsParams) => {
        setIsLoading(true);
        const startRow = params.request.startRow ? params.request.startRow : 0;
        const endRow = params.request.endRow;
        let pageSize = 10;
        if (
          endRow !== null &&
          endRow !== undefined &&
          startRow !== null &&
          startRow !== undefined
        ) {
          pageSize = endRow - startRow;
        }
        const pageNumber = startRow / pageSize;

        userImportTracking
          .getImportTracking(
            tenant,
            pageNumber,
            pageSize,
            fileNameOne,
            statusOne,
            startDateFrom,
            startDateTo,
            type
          )
          .then((response: any) => {
            params.successCallback(
              managerData(response),
              response.data.totalElements
            );
            if (length <= response.data.totalElements) {
              setLength(response.data.totalElements);
            }
            setIsLoading(false);
          })
          .catch((error: any) => {
            if (error.response) {
              dispatchGlobalData({
                type: setSnackbar,
                payload: {
                  snackbar: {
                    message: error.response.data.error,
                    type: snackbarTypes.error,
                    show: true,
                    autoClose: true,
                  },
                },
              });
              setIsLoading(false);
            } else if (error.request) {
              dispatchGlobalData({
                type: setSnackbar,
                payload: {
                  snackbar: {
                    message: t("networkErrorMessage"),
                    type: snackbarTypes.error,
                    show: true,
                    autoClose: true,
                  },
                },
              });
              setIsLoading(false);
            } else {
            }
          });
      },
    };
  };
  const exportDataImportTracking = async () => {
    setIsLoading(true);
    let fileName = !!dataFormSearchFieldImportTracking.fileName
      ? dataFormSearchFieldImportTracking.fileName.trim()
      : null;
    let status = !!dataFormSearchFieldImportTracking.status
      ? dataFormSearchFieldImportTracking.status.trim()
      : null;
    let startDateFrom = dayjs(
      dataFormSearchFieldImportTracking?.startDateFrom
    ).isValid()
      ? dayjs
          .utc(dataFormSearchFieldImportTracking?.startDateFrom)
          .format("YYYY-MM-DDTHH:mm:ssZ")
      : null;
    let startDateTo = dayjs(
      dataFormSearchFieldImportTracking?.startDateTo
    ).isValid()
      ? dayjs
          .utc(dataFormSearchFieldImportTracking?.startDateTo)
          .format("YYYY-MM-DDTHH:mm:ssZ")
      : null;
    userImportTracking
      .exportDataImportTracking(
        tenant,
        fileName,
        status,
        startDateFrom,
        startDateTo
      )
      .then((response: any) => {
        setIsLoading(false);
        const filename =
          response.headers["content-disposition"].split("filename=")[1];
        var blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        FileSaver.saveAs(blob, filename);
      });
  };

  const exportFileImportTrackingDataById = async (id: string) => {
    setIsLoading(true);
    userImportTracking
      .exportFileImportTrackingDataById(tenant, id)
      .then((response: any) => {
        setIsLoading(false);
        const filename =
          response.headers["content-disposition"].split("filename=")[1];
        var blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        FileSaver.saveAs(blob, filename);
      });
  };

  const exportErrorFileImportTrackingDataById = async (id: string) => {
    setIsLoading(true);
    userImportTracking
      .exportErrorImportTrackingDataById(tenant, id)
      .then((response: any) => {
        setIsLoading(false);
        const filename =
          response.headers["content-disposition"].split("filename=")[1];
        var blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        FileSaver.saveAs(blob, filename);
      });
  };

  const handleFileColumnClick = (param: any) => {
    exportFileImportTrackingDataById(param.data.id);
  };
  const handleErrorFileColumnClick = (param: any) => {
    exportErrorFileImportTrackingDataById(param.data.id);
  };

  function managerData(response: any) {
    let rows: any[] = [];
    response.data.content.forEach((element: any) => {
      let row = {
        userId: element.id,
        fileName: element.filename,
        startDate: element.startDate,
        endDate: element.endDate,
        errorFilename: element.errorFilename,
        absPathErrorFile: element.absPathErrorFile,
        status: element.status,
        id: element.id,
      };
      rows.push(row);
    });
    return rows;
  }
  const resetFormTextImportTracking = () => {
    setDataFormSearchFieldImportTracking({
      fileName: "",
      status: null,
      startDateFrom: null,
      startDateTo: null,
    });

    setResetFormValueImportTracking(!resetFormValueImportTracking);
  };

  const onGridReady = (params: any) => {
    setGridApi(params.api);
  };

  useEffect(() => {
    if (gridApi) {
      gridApi.setServerSideDatasource(SearchImportTracking());
    }
  }, [gridApi, resetFormValueImportTracking]);

  return (
    <>
      <SectionHeader
        title={ type === "VEHICLE" ? t("sapImport.titleFirst") + " " + t("sapImport.titleSecond") : t("sapImport.titleTelematics")}
      />
      <SapImportFilterAndSearch
        dataFormSearchFieldImportTracking={dataFormSearchFieldImportTracking}
        setDataFormSearchFieldImportTracking={
          setDataFormSearchFieldImportTracking
        }
        setResetFormValueImportTracking={setResetFormValueImportTracking}
        resetFormValueImportTracking={resetFormValueImportTracking}
        resetFormTextImportTracking={resetFormTextImportTracking}
      />
      <Box className="carGenericOuterTableBox">
        <Box>
          <Card>
            <Box
              minHeight={46}
              pr={1}
              display="flex"
              justifyContent={"flex-end"}
              alignItems="center"
            >
              <Tooltip title={t("tooltipTitle.download")}>
                <IconButton
                  color="accent"
                  disabled={length === 0 ? true : false}
                  onClick={exportDataImportTracking}
                >
                  <FileDownloadIcon />
                </IconButton>
              </Tooltip>
            </Box>
          </Card>
        </Box>
        <Box>
          <AgGridOperationTable
              columnDefs={columnDefs}
              onGridReady={onGridReady}
              cacheBlockSize={pageSize}
              serverSideInfiniteScroll={true}
              rowModelType={"serverSide"}
              totalElements={length}
            />

        </Box>
        {loading && <CustomLoader loading={loading} />}
      </Box>
    </>
  );
};
